import { Inspection } from '@stormwater-software/lib-inspection-templates';
import xhrService from '../xhrService';
const baseUrl = '/api/projects';

type ProjectInspection = Omit<Inspection, 'id'> & {
  id: number;
};

export const projectSiteMapInspection = {
  index: (id: number, siteMapId: number): Promise<ProjectInspection[]> => {
    return xhrService
      .get(`${baseUrl}/${id}/sitemaps/${siteMapId}/inspections`)
      .then((response) => response.data);
  },
  /**
   * SW2-2345 — the Form Type options for THIS dialog.
   *
   * Not the shared `/inspection-template-types/unique`, which the inspection and SWMP
   * dialogs use and which lists every form the project runs. This one lists only the
   * forms that have maps to draw, so selecting one cannot land on another form's maps.
   */
  formTypes: (id: number): Promise<{ id: number; name: string }[]> => {
    return xhrService
      .get(`${baseUrl}/${id}/sitemaps/form-types`)
      .then((response) => response.data);
  },

  show: (id: number): Promise<ProjectInspection[]> => {
    return xhrService
      .get(`${baseUrl}/${id}/sitemaps/inspections`)
      .then((response) => response.data);
  },
};

export default projectSiteMapInspection;
